import type { RouteObject } from "react-router-dom";
import Layout from "../../src/components/feature/Layout";
import Home from "../../src/pages/home/page";
import CategoryPage from "../../src/pages/category/page";
import ArticlePage from "../../src/pages/article/page";
import AboutPage from "../../src/pages/about/page";
import NotFound from "../../src/pages/NotFound";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/category/:slug",
        element: <CategoryPage />,
      },
      {
        path: "/article/:id",
        element: <ArticlePage />,
      },
      {
        path: "/about",
        element: <AboutPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;